import { ObservableArray, View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement } from "src/formBuilder/structure/element";
import { ComponentListStore } from "../templateEditor-viewModel";

export class ElementCompactViewView extends View<FormBuilderElement>{
    GetViewUniqueId(): string {
        return "V-5C2B4C34-14A0-4557-9061-2B1F78292691"
    }
    loadHtml(): string {
        let element = require('./elementCompactView.html').default;
        let style = require('./elementCompactView.less');
        return element;
    }
    constructor() {
       super();
        this.items = ObservableArray.create<FormBuilderComponent>();
    }

    public set typeName(v: string) { this._typeName = v; } public get typeName(): string { return this._typeName;} private _typeName: string;
    public set items(v: ObservableArray<FormBuilderComponent>) { this._items = v; } public get items(): ObservableArray<FormBuilderComponent> { return this._items;} private _items: ObservableArray<FormBuilderComponent>;
    public set selectedItem(v: FormBuilderComponent) { this._selectedItem = v; } public get selectedItem(): FormBuilderComponent { return this._selectedItem;} private _selectedItem: FormBuilderComponent;
    
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    
    async removeElementFromParent(){
       this.dataContext.removeElementFromParent();
    }

    async confirm(){
        this.isShowingPopup = false;
        let self = this.dataContext.self;
        let parent :any = self.decoratorHead.parentViewModel;
        await self.removeElementFromParent();
        let newParent:any = this.selectedItem.Create(parent);
        parent.addChild(newParent);
        let newSelf = self.component.decorate(newParent.self,self);
        newParent.addChild(newSelf);
        // if(this.selectedItem!=null)
        //     alert(this.selectedItem.name);
    }

    addAsParent(e){
        if(this.items.length==0){
            this.items.update(...new ComponentListStore().getAllContainers(this.dataContext))
        }
        this.isShowingPopup = true;
        e.stopPropagation();
    }
}

